import { render, staticRenderFns } from "./myAccountSettings.vue?vue&type=template&id=5319ba07&scoped=true&"
import script from "./myAccountSettings.vue?vue&type=script&lang=js&"
export * from "./myAccountSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5319ba07",
  null
  
)

export default component.exports